/**
 * Test scenario definitions for OpenPurchaseOrdersResultsPanel test mode.
 *
 * Each PO in these test files has a realistic cube total (1900–2250 cubes),
 * matching approximate real-world PO sizing. SKUC (the zero-demand filler SKU)
 * uses cubeSize=10 with varying quantities to pad each PO to the target range.
 *
 * Cube ranges shown in each label reflect the min/max cubeTotal across all POs
 * in that file (variation is caused by differing SKUA/SKUB quantities per PO tier).
 */
interface TestScenario {
  category: string;
  label: string;
  filename: string;
}

export const TEST_SCENARIOS: TestScenario[] = [
  {
    category: "Warehouse 99 - Baseline (FL)",
    label: "CAT1 · Critical Only · MOVES: YES — 12 POs · 2,008–2,210 cubes/PO",
    filename: "CAT1_Critical_MOVES-YES.json",
  },
  {
    category: "Warehouse 99 - Baseline (FL)",
    label:
      "CAT1 · Critical Only · MOVES: NO — 10 POs (wrong direction) · 2,003–2,210 cubes/PO",
    filename: "CAT1_Critical_MOVES-NO.json",
  },
  {
    category: "Warehouse 99 - Baseline (FL)",
    label:
      "CAT2 · Critical + Moderate · MOVES: YES — 15 POs · 1,903–2,215 cubes/PO",
    filename: "CAT2_CritAndMod_MOVES-YES.json",
  },
  {
    category: "Warehouse 99 - Baseline (FL)",
    label:
      "CAT2 · Critical + Moderate · MOVES: NO — 10 POs (wrong direction) · 1,903–2,215 cubes/PO",
    filename: "CAT2_CritAndMod_MOVES-NO.json",
  },
  {
    category: "Warehouse 99 - Baseline (FL)",
    label: "CAT3 · WOS Balance · MOVES: YES — 14 POs · 1,940–2,201 cubes/PO",
    filename: "CAT3_WOS-Balance_MOVES-YES.json",
  },
  {
    category: "Warehouse 99 - Baseline (FL)",
    label:
      "CAT3 · WOS Balance · MOVES: NO — 12 POs (wrong direction) · 1,920–2,213 cubes/PO",
    filename: "CAT3_WOS-Balance_MOVES-NO.json",
  },
  {
    category: "Warehouse 99 - Baseline (FL)",
    label:
      "CAT2 · All Three Reasons · MOVES: YES — 20 POs (MultiTier) · 1,902–2,238 cubes/PO",
    filename: "CAT2_CritAndMod_MultiTier.json",
  },
  {
    category: "Warehouse 12 - TX",
    label:
      "CAT4 · Critical Focus · MOVES: YES — TX Warehouse 12 · 12 POs · 2,008–2,210 cubes/PO",
    filename: "CAT4_Critical_TX-WH12_MOVES-YES.json",
  },
  {
    category: "Warehouse 21 - SE",
    label:
      "CAT5 · Critical + Moderate · MOVES: YES — SE Warehouse 21 · 15 POs · 1,903–2,215 cubes/PO",
    filename: "CAT5_CritAndMod_SE-WH21_MOVES-YES.json",
  },
  {
    category: "Warehouse 77 - FL",
    label:
      "CAT6 · WOS Balance · MOVES: YES — FL Warehouse 77 · 14 POs · 1,940–2,201 cubes/PO",
    filename: "CAT6_WOS-Balance_FL-WH77_MOVES-YES.json",
  },
  {
    category: "Multi-Warehouse TX (12 + 13)",
    label:
      "CAT7 · Critical Focus · MOVES: YES — TX Warehouses 12 + 13 · 12 POs · 2,008–2,210 cubes/PO",
    filename: "CAT7_Critical_TX-WH12-WH13_MOVES-YES.json",
  },
  {
    category: "Multi-Warehouse SE (21 + 22)",
    label:
      "CAT8 · Critical + Moderate · MOVES: YES — SE Warehouses 21 + 22 · 15 POs · 1,903–2,215 cubes/PO",
    filename: "CAT8_CritAndMod_SE-WH21-WH22_MOVES-YES.json",
  },
  {
    category: "Multi-Warehouse FL (77 + 78)",
    label:
      "CAT9 · WOS Balance · MOVES: YES — FL Warehouses 77 + 78 · 14 POs · 1,940–2,201 cubes/PO",
    filename: "CAT9_WOS-Balance_FL-WH77-WH78_MOVES-YES.json",
  },
];
